export default __webpack_public_path__ + "static/media/pdf.0ac36a96.svg";